import {Component, OnInit} from '@angular/core';
import {DocumentViewerPageComponent} from '../../shared/components/document-viewer-page/document-viewer-page.component';
import {LangService} from '../../core/services/lang.service';
import {LegalDocumentsService} from '../../core/services/legal-documents.service';
import {NgIf} from '@angular/common';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  imports: [DocumentViewerPageComponent, NgIf]
})
export class PrivacyPolicyComponent implements OnInit {
  url: string = '';

  constructor(private langService: LangService, private legalDocumentsService: LegalDocumentsService) {
  }

  ngOnInit(): void {
    this.legalDocumentsService.getPrivacyPolicy(this.langService.currentLang()).subscribe(url => {
      this.url = url;
    });
  }
}
